import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Truck } from 'lucide-react';
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="bg-white shadow-sm" data-id="element-52">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-53">
        <Link to="/" className="flex items-center space-x-2" data-id="element-54">
          <Truck className="h-8 w-8 text-blue-600" data-id="element-55" />
          <span className="text-xl font-bold text-gray-800" data-id="element-56">EstMove</span>
        </Link>
        {/* Mobile menu button */}
        <button className="md:hidden p-2" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-57">
          {isMenuOpen ? <X className="h-6 w-6 text-gray-700" data-id="element-58" /> : <Menu className="h-6 w-6 text-gray-700" data-id="element-59" />}
        </button>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-60">
          <Link to="/" className="text-gray-700 hover:text-blue-600" data-id="element-61">
            Home
          </Link>
          <Link to="/order" className="text-gray-700 hover:text-blue-600" data-id="element-62">
            Book a Move
          </Link>
          <Link to="/tracking" className="text-gray-700 hover:text-blue-600" data-id="element-63">
            Track Order
          </Link>
          <Link to="/order" className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700" data-id="element-64">
            Get a Quote
          </Link>
        </nav>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-white shadow-lg absolute w-full z-10" data-id="element-65">
          <div className="container mx-auto px-4 py-2 flex flex-col space-y-3" data-id="element-66">
            <Link to="/" className="text-gray-700 hover:text-blue-600 py-2" onClick={() => setIsMenuOpen(false)} data-id="element-67">
              Home
            </Link>
            <Link to="/order" className="text-gray-700 hover:text-blue-600 py-2" onClick={() => setIsMenuOpen(false)} data-id="element-68">
              Book a Move
            </Link>
            <Link to="/tracking" className="text-gray-700 hover:text-blue-600 py-2" onClick={() => setIsMenuOpen(false)} data-id="element-69">
              Track Order
            </Link>
            <Link to="/order" className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 text-center" onClick={() => setIsMenuOpen(false)} data-id="element-70">
              Get a Quote
            </Link>
          </div>
        </div>}
    </header>;
};
export default Header;